import { Button, MenuItem, Stack } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import { useForm } from "react-hook-form";
import { SALES_ORDER_STATUS } from "../../../utils/constants";
import RhfTextField from "../../form/RhfTextField";

const emptySearchInputs = {
  so_ref: "",
  customer: "",
};

function SalesOrdersSearchForm({ onSubmit, isSearchDisabled }) {
  const {
    handleSubmit,
    control,
    reset,
    formState: { isDirty },
  } = useForm({
    defaultValues: emptySearchInputs,
  });

  const resetForm = () => {
    reset();
    onSubmit();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Stack flexDirection="row">
        <RhfTextField
          label="Reference"
          name="so_ref"
          control={control}
          size="small"
          sx={{ mr: 2, mb: 2, width: 140 }}
          variant="standard"
          inputProps={{ maxLength: 31 }}
        />
        <RhfTextField
          label="Customer"
          name="customer"
          control={control}
          size="small"
          sx={{ mr: 2, mb: 2 }}
          variant="standard"
        />
        <RhfTextField
          name="status"
          control={control}
          select
          label="Status"
          size="small"
          variant="standard"
          sx={{ mr: 2, mb: 2, width: 140 }}
        >
          {Object.keys(SALES_ORDER_STATUS).map((key) => {
            const status = SALES_ORDER_STATUS[key];
            return (
              <MenuItem value={status.value} key={status.value}>
                {status.label}
              </MenuItem>
            );
          })}
        </RhfTextField>
        <Button
          sx={{ mr: 2, mb: 2 }}
          color="primary"
          type="submit"
          variant="contained"
          disabled={isSearchDisabled}
        >
          Search
        </Button>
        <Button
          color="error"
          variant="contained"
          onClick={resetForm}
          disabled={!isDirty}
          sx={{ mb: 2 }}
        >
          Clear
        </Button>
      </Stack>
    </form>
  );
}

SalesOrdersSearchForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isSearchDisabled: PropTypes.bool,
};

SalesOrdersSearchForm.defaultProps = {
  isSearchDisabled: false,
};

export default SalesOrdersSearchForm;
